(() => {
  const root = document.querySelector('.nw-shop');
  if (!root) return;
  const carousel = root.querySelector('[data-product-carousel]');
  if (carousel) {
    const track = carousel.querySelector('[data-carousel-track]');
    const slides = Array.from(carousel.querySelectorAll('.nw-carousel__slide'));
    const tabs = Array.from(carousel.querySelectorAll('[data-carousel-to]'));
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const count = carousel.querySelector('[data-carousel-count]');
    const viewport = carousel.querySelector('.nw-carousel__viewport');
    let current = 0;
    let pointerStartX = null;

    const showSlide = (target) => {
      if (!track || !slides.length) return;
      current = (target + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + (current * 100) + '%, 0, 0)';

      slides.forEach((slide, index) => {
        const active = index === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });

      tabs.forEach((tab, index) => {
        const active = index === current;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      if (count) count.textContent = (current + 1) + ' / ' + slides.length;
    };
    previous?.addEventListener('click', () => showSlide(current - 1));
    next?.addEventListener('click', () => showSlide(current + 1));
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => showSlide(Number(tab.dataset.carouselTo)));
    });

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(current - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(current + 1);
      }
    });

    track?.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
      track.setPointerCapture?.(event.pointerId);
    });
    track?.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 45) return;
      showSlide(distance > 0 ? current - 1 : current + 1);
    });
    track?.addEventListener('pointercancel', () => {
      pointerStartX = null;
    });
    track?.addEventListener('dragstart', (event) => event.preventDefault());

    showSlide(0);
  }

  const productForm = root.querySelector('[data-product-form]');
  const addLabel = productForm?.querySelector('[data-add-label]');
  const mobilePrice = root.querySelector('[data-mobile-price]');

  root.querySelectorAll('.nw-shop-pack input[name="id"]').forEach((input) => {
    input.addEventListener('change', () => {
      const selectedPack = input.closest('.nw-shop-pack');
      const selectedPrice = selectedPack
        ?.querySelector('.nw-shop-pack__price strong')
        ?.textContent.trim();

      if (!selectedPrice) return;
      if (addLabel) addLabel.textContent = 'ADD TO CART — ' + selectedPrice;
      if (mobilePrice) mobilePrice.textContent = selectedPrice;
    });
  });
})();